import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { ActionComponent } from '../../../../../ui/api/action.component';
import { LocalVimeoPlayerComponent } from '../../../../../ui/display/media/vimeo-player.component';
import { config } from './overlapped-component.config';
import { IPageComponentOverlappedComponentData } from './overlapped-component.interface';

@Component({
    selector: 'page-component-overlapped-component',
    templateUrl: './overlapped-component.html',
    styleUrl: './overlapped-component.scss',
    standalone: true,
    imports: [ActionComponent, CommonModule, DfImageDirective, HrefComponent, ICmsClientModule, LocalVimeoPlayerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentOverlappedComponent>(config)
export class PageComponentOverlappedComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentOverlappedComponentData;
}
